<template>
  <div>
    <div
      :class="['top-tasks', isOpenTaskDrop ? 'active' : '']"
      @click="tasks.length != 0 ? openCloseDrop() : ''"
    >
      <div class="top-tasks-no sysnotif-animation">
        {{ number_of_notifications }}
      </div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="25"
        viewBox="0 0 20 25"
      >
        <g>
          <g>
            <path
              fill="#2b2b41"
              d="M19.279 20.842a2.778 2.778 0 0 1-2.164 1.04h-4.294c0 1.59-1.261 2.882-2.812 2.882-1.55 0-2.812-1.293-2.812-2.881H2.885c-.84 0-1.628-.38-2.164-1.04a2.926 2.926 0 0 1-.6-2.373c.324-1.772.965-2.92 1.53-3.933.574-1.029 1.028-1.841 1.028-3.12v-1.44c0-3.785 2.79-6.952 6.374-7.429V1.142c0-.53.42-.96.938-.96s.937.43.937.96v1.403a7.177 7.177 0 0 1 4.27 2.176 7.546 7.546 0 0 1 2.105 5.255v1.44c0 .974.263 1.662.717 2.52a.972.972 0 0 1-.379 1.302.915.915 0 0 1-.445.116.934.934 0 0 1-.825-.504c-.456-.862-.943-1.91-.943-3.433v-1.44c0-3.029-2.395-5.526-5.34-5.57h-.177c-2.955.044-5.358 2.541-5.358 5.57v1.44c0 1.789-.648 2.95-1.274 4.073-.516.924-1.05 1.88-1.316 3.334a.966.966 0 0 0 .2.792c.106.13.339.347.722.347h14.23a.917.917 0 0 0 .721-.347.966.966 0 0 0 .2-.792.959.959 0 0 1 .75-1.121.939.939 0 0 1 1.093.767 2.926 2.926 0 0 1-.6 2.372zm-8.332 1.04H9.07c0 .53.421.961.938.961a.95.95 0 0 0 .938-.96z"
            />
          </g>
        </g>
      </svg>
    </div>
    <div class="top-tasks-menu sysnot">
      <div
        class="task-element-wrapper"
        v-for="(single_task, key) in tasks"
        :key="key"
        :class="hasBeenRead(single_task) ? 'unread-notification' : 'read'"
        @click="redirectToUrl(single_task.link)"
      >
        <!-- <div :class="'vrsta-eventa event-blue'" v-if="">
          NOVO
        </div> -->
        <div class="task-date">
          <div>
            {{ formatTime(single_task.created) }}
          </div>
          <div>
            {{ formatDate(single_task.created) }}
          </div>
        </div>
        <div class="task-date-name-wrapper">
          <div class="task-name">
            {{ single_task.title }}
          </div>
        </div>
      </div>
      <!-- <div class="task-divider"></div> -->
    </div>
  </div>
</template>

<script>
import gsap from "gsap";
import CalendarModal from "@/components/calendarComponents/CalendarModal.vue";
import NotificationComponent from "@/components/generalComponents/NotificationComponent.vue";
import TasksDropdown from "@/components/generalComponents/TasksDropdown.vue";
import person from "@/apiCallers/promise_handler_db/person";
import moment from "moment";

export default {
  components: { CalendarModal, NotificationComponent, TasksDropdown },
  props: {
    sioVar: {
      type: Object,
      required: false,
      default: null,
    },
  },
  methods: {
    openCloseDrop() {
      this.$parent.$refs.taskDrop.isOpenTaskDrop = false;
      this.isOpenTaskDrop = !this.isOpenTaskDrop;
    },
    formatTime(dt_data) {
      return moment(dt_data).format("LT");
    },
    formatDate(dt_data) {
      if (moment(dt_data).format("L") == moment().format("L")) {
        return "danas";
      } else return moment(dt_data).format("DD.MMMM ");
    },
    redirectToUrl(red_url) {
      window.location.replace(red_url);
    },
    hasBeenRead(singl_task) {
      console.log(
        "Has been read",
        new Date(this.$store.state.logged_in_user.last_check_notifications) <
          new Date(singl_task.created)
      );
      if (
        new Date(this.$store.state.logged_in_user.last_check_notifications) <
        new Date(singl_task.created)
      )
        return true;
      else return false;
    },
    calculate_notifications: function () {
      this.number_of_notifications = this.tasks.filter(
        (p) =>
          new Date(p.created) >
          new Date(this.$store.state.logged_in_user.last_check_notifications)
      ).length;
    },
  },

  watch: {
    sioVar: function () {
      if (this.sioVar != null) {
        this.sioVar.socket.on("message sysnot", (data) => {
          console.log("Got new data");
          let old_length = this.tasks.length;
          this.tasks = [];
          this.tasks = JSON.parse(data);
          if (this.hasFirstLoaded) {
            if (old_length > this.tasks.length) {
              console.log("A task has been solved.");
              // gsap.to(".sysnotif-animation", 1, { width: "5rem", height: "5rem", backgroundColor: "#0acab1" })
              // gsap.to(".sysnotif-animation", 1, { delay: 3, width: "2rem", height: "2rem" })
              // gsap.to(".sysnotif-animation", 0.4, { delay: 4, backgroundColor: "#fd4087" })
            } else if (old_length < this.tasks.length) {
              if (Notification.permission == "granted") {
                // let notifi = this.sw_worker.showNotification("Ovo je neki naslov", {
                //   body: this.tasks[0].title,
                //   vibrate: [200, 100, 200, 100, 200, 100, 200],
                //   silent: false,
                //   badge: require("@/assets/novi-crveni-legal.svg"),
                //   icon: require("@/assets/novi-crveni-legal.svg"),
                //   tag: "vibration-sample"
                // })

                let notifi = new Notification("Obavijest sustava Firmwide", {
                  body: this.tasks[0].title,
                  silent: false,
                  icon: require("@/assets/novi-crveni-legal.svg"),
                  badge: require("@/assets/novi-crveni-legal.svg"),
                  timestamp: Math.floor(Date.now()),
                });

                // notifi.notificationclick = (event) => {
                //   event.preventDefault(); // prevent the browser from focusing the Notification's tab
                //   this.redirectToUrl(this.tasks[0].link)
                // }
              }
              console.log("A task has been addded.");
              gsap.to(".sysnotif-animation", 1, {
                width: "5rem",
                height: "5rem",
              });
              gsap.to(".sysnotif-animation", 1, {
                delay: 3,
                width: "2rem",
                height: "2rem",
              });
            }
            this.calculate_notifications();
          } else {
            this.hasFirstLoaded = true;
            this.calculate_notifications();
            if (
              this.number_of_notifications > 0 &&
              Notification.permission == "granted"
            ) {
              let notifi = new Notification("Obavijest sustava Firmwide", {
                body:
                  "Dobrodošli u Firmwide sustav. Imate " +
                  this.number_of_notifications +
                  " novih obavijesti.",
                silent: false,
                icon: require("@/assets/novi-crveni-legal.svg"),
                badge: require("@/assets/novi-crveni-legal.svg"),
                timestamp: Math.floor(Date.now()),
              });
            }
          }
        });
      }
    },
    isOpenTaskDrop: async function () {
      if (!this.isOpenTaskDrop) {
        if (
          !this.$parent.isOpenDropDown &&
          !this.$parent.$refs.taskDrop.isOpenTaskDrop
        ) {
          gsap.to(".router-wrapper", 0.5, {
            filter: "none",
            pointerEvents: "auto",
            opacity: 1,
          });
        }
        let tl = gsap.timeline();
        tl.fromTo(".sysnot", 0.3, { y: 0 }, { y: -20, opacity: 0 });

        tl.to(".sysnot", 0, { display: "none" });
        this.calculate_notifications();
      } else {
        // console.log(this.$store.state.logged_in_user.uid)
        if (this.number_of_notifications > 0) {
          await person
            .openedNotifications(this.$store.state.logged_in_user.uid)
            .then((resp) => {
              this.$store.state.logged_in_user.last_check_notifications =
                resp.data.date_update;
            });
        }
        gsap.to(".router-wrapper", 0.5, {
          filter: "blur(5px)",
          pointerEvents: "none",
          opacity: 0.5,
        });
        let tl = gsap.timeline();
        tl.to(".tasknot", 0, { display: "none" });
        tl.to(".sysnot", 0, { display: "block" });
        tl.fromTo(".sysnot", 0.3, { y: -20 }, { y: 0, opacity: 1 });
        tl.fromTo(".tasknot", 0.3, { y: 0 }, { y: -20, opacity: 0 });
      }
    },
  },
  data() {
    return {
      isOpenTaskDrop: false,
      tasks: [],
      hasFirstLoaded: false,
      number_of_notifications: 0,
      sw_worker: null,
    };
  },
  async created() {
    if (Notification.permission == "granted") {
      const swRegistration = await navigator.serviceWorker.register(
        "service.js"
      );
      this.sw_worker = swRegistration;
    }
  },
  mounted() {},
};
</script>
